"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setChildForm = exports.setFormIndex = exports.setActiveForm = void 0;
// =======
// ACTIONS
// =======
const constants_1 = require("../constants");
// ===============
// ACTION CREATORS
// ===============
const setActiveForm = (id, childId) => (dispatch, getState) => {
    const { rex } = getState();
    const index = childId ? rex.childNames[id][childId] : 0;
    dispatch({
        type: constants_1.SET_ACTIVE_FORM,
        version: rex.version[id],
        id,
        index,
    });
};
exports.setActiveForm = setActiveForm;
const setFormIndex = (index) => (dispatch, getState) => {
    const { rex } = getState();
    dispatch({
        type: constants_1.SET_ACTIVE_FORM,
        version: rex.version[rex.currentForm.id],
        index,
    });
};
exports.setFormIndex = setFormIndex;
const setChildForm = (childId) => (dispatch, getState) => {
    const { rex } = getState();
    dispatch({
        type: constants_1.SET_ACTIVE_FORM,
        version: rex.version[rex.currentForm.id],
        index: rex.childNames[rex.currentForm.id][childId],
    });
};
exports.setChildForm = setChildForm;
// =======
// REDUCER
// =======
const currentForm = (state = { stage: 0, index: 0, id: '' }, action) => {
    switch (action.type) {
        case constants_1.LOAD_NEW_FORMS: {
            return {
                id: action.id,
                index: action.version > 1 ? 0 : action.index || 0,
                stage: action.index || 0,
            };
        }
        case 'FormModel/LOAD_FORM': {
            return {
                id: action.payload.modelKey,
                index: 0,
                stage: 0,
            };
        }
        case constants_1.SET_ACTIVE_FORM: {
            return {
                id: action.id || state.id,
                index: action.version > 1 ? 0 : action.index || 0,
                stage: action.index || 0,
            };
        }
        case constants_1.REMOVE_FORM: {
            return state.id === action.id ? { stage: 0, index: 0, id: '' } : state;
        }
        default:
            return state;
    }
};
exports.default = currentForm;
//# sourceMappingURL=current-form.js.map